<template>
  <div>
    <card style="margin-bottom: 0px;border-bottom: none;border-bottom-left-radius: 0;border-bottom-right-radius: 0;">
      <template slot="header">
        {{ product ? product.name : '' }}
      </template>
    </card>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Lager</th>
          <th class="text-center">Derzeitiger Lagerstand</th>
          <th class="text-center">
            Warnschwelle
            <span v-tooltip.top-center="'Wird dieser Wert unterschritten wird eine Warnung angezeigt, dass das Produkt nachbestellt werden muss'">
              <i class="fas fa-question-circle"></i>
            </span>
          </th>
          <th class="text-center">
            Sollmenge
            <span v-tooltip.top-center="'Hier können Sie den Ziellagerstand den Sie im Lager anstreben angeben, dies ist hilfreich um z.B. bei Neubestellung wenn die Warnschwelle erreicht ist zu wissen, wieviel Produkte bestellt werden sollen'">
              <i class="fas fa-question-circle"></i>
            </span>
          </th>
          <th style="width: 50px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="productWarehouse in productWarehouses"
          :key="productWarehouse.id"
          :product-warehouse="productWarehouse"
          is="ProductWarehouseConfigRow"
        >
        </tr>
      </tbody>
      <tfoot>
        <tr style="border-top: 4px double;">
          <td colspan="2" class="text-right">{{ inStock }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import ProductWarehouseConfigRow from './ProductWarehouseConfigRow.vue'

export default {
  props: [],
  components: {
    ProductWarehouseConfigRow
  },
  data () {
    return {
      product: null,
      productWarehouses: []
    }
  },
  methods: {
  },
  computed: {
    inStock () {
      return this.productWarehouses.reduce((sum, warehouse) => sum + (warehouse.stock_rotations.length ? +warehouse.stock_rotations[0].quantity_sum : 0), 0)
    }
  },
  created () {
    this.$http.get(`/products/${this.$route.params.id}`).then(({ data }) => {
      this.product = data
    })
    this.$http.get(`products/${this.$route.params.id}/warehouse_config`).then(({ data }) => {
      this.productWarehouses = data
    })
  }
}
</script>
